import fromPairs from "lodash/fromPairs"
import formatStoredField from "shared/lib/format_stored_field"

const initialState = {
  byService: {},
}

export default function queries(state = initialState, event) {
  switch (event.type) {
    default: {
      return state
    }

    case "QUERIES_LOADED": {
      const queries = fromPairs(
        event.queries.map(query => {
          return [
            query.module_name,
            {
              ...query,
              channel_module_name: event.serviceModuleName,
              fields: query.query_fields.map(queryField => ({
                ...queryField,
                stored_field: formatStoredField(
                  "query",
                  query.full_module_name,
                  queryField
                ),
              })),
            },
          ]
        })
      )

      return {
        ...state,
        byService: {
          ...state.byService,
          [event.serviceModuleName]: queries,
        },
      }
    }
  }
}

export const queryQueryFields = `
  module_name
  full_module_name
  name
  description
  id
  normalized_module_name

  channel {
    id
    module_name
    normalized_module_name
  }

  ingredients {
    id
    name
    normalized_name
    example
    value_type
  }

  query_fields {
    id
    name
    label
    field_ui_type
    field_type
    required
    normalized_field_type
    shareable
    hideable
    can_have_default
    helper_text
    normalized_module_name
  }
`
